
export default (https) => ({
  async getList(params = []) {
    const queryString = params
      .filter(param => param.value !== null && param.value !== undefined && param.value !== '')
      .map(param => `${encodeURIComponent(param.key)}=${encodeURIComponent(param.value)}`)
      .join('&');

    const response = await https.get(`/productions?${queryString}`);
    return response.data;
  },

  async exportList(payload = {}) {
    const response = await https.post('/productions/export', payload);
    return response;
  },

  async getById(id) {
    const response = await https.get(`/productions/${id}`);
    return response.data.data;
  },

  async add(payload) {
    const response = await https.post(`/productions`, payload);
    return response.data;
  },

  /**
   * Record a delta in how much of a line has actually been produced.
   * Replaces the retired productionStatus()/production-product-status —
   * status is derived server-side from recorded quantities now, not set by
   * clicking a label. `change` is a DELTA ("made 40 more today"), not a new
   * total; pass a negative number to correct an overcount.
   */
  async recordProgress({ production_product_id, change, note = null }) {
    const response = await https.post(`/production-product-progress`, {
      production_product_id, change, note,
    });
    return response.data;
  },

  /** Only reachable while every line has zero recorded progress. */
  async cancelProduction(id, reason = null) {
    const response = await https.post(`/productions/${id}/cancel`, { reason });
    return response.data;
  },

  /** Stops a partially-produced run on purpose; keeps its credited quantity. Requires a reason. */
  async closeProduction(id, reason) {
    const response = await https.post(`/productions/${id}/close`, { reason });
    return response.data;
  },

  /** Reverses a Close; status is recomputed from the lines' current progress. */
  async reopenProduction(id, reason = null) {
    const response = await https.post(`/productions/${id}/reopen`, { reason });
    return response.data;
  },

  /**
   * Production lines planned within a date window.
   *
   * `to` is EXCLUSIVE, matching FullCalendar's datesSet end, which is the instant
   * after the visible range — pass its endStr straight through.
   */
  async getSchedule({ from, to, includeUnscheduled = false, search = '', page = 1 }) {
    const params = new URLSearchParams({ from, to });
    if (includeUnscheduled) {
      params.append('include_unscheduled', '1');
      params.append('page', page);
      if (search) params.append('search', search);
    }
    const response = await https.get(`/productions-schedule?${params.toString()}`);
    return response.data.data;
  },

  /** Move one line to another day. A null date returns it to the backlog. */
  async rescheduleProduct(payload) {
    const response = await https.post(`/production-product-schedule`, payload);
    return response.data;
  },


  async update(id, payload) {
    const response = await https.put(`/productions/${id}`, payload);
    return response.data;
  },

  async deleteById(id) {
    const response = await https.delete(`/productions/${id}`);
    return response.data;
  },


  async import(file) {
    const formData = new FormData();
    formData.append('excel_file', file);
    const response = await https.post(`/production-product-import`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

});

